import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { colors } from '@flowio/react-theme';
import React from 'react';
var rootStyles = /*#__PURE__*/css({
  position: 'relative',
  border: "1px solid ".concat(colors.GRAY_300),
  borderRadius: '0.25rem',
  backgroundColor: colors.WHITE,
  boxSizing: 'border-box',
  '& ~ &': {
    marginTop: '1.5rem'
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NhcmQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlCbUIiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQ2FyZC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cblxuaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBjb2xvcnMgfSBmcm9tICdAZmxvd2lvL3JlYWN0LXRoZW1lJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbnR5cGUgT3duUHJvcHMgPSB7XG4gIGNoaWxkcmVuPzogUmVhY3QuUmVhY3ROb2RlO1xufTtcblxudHlwZSBVbmhhbmRsZWRQcm9wcyA9IE9taXQ8XG4gIFJlYWN0LkhUTUxBdHRyaWJ1dGVzPEhUTUxEaXZFbGVtZW50PixcbiAga2V5b2YgT3duUHJvcHNcbj47XG5cbnR5cGUgUHJvcHMgPSBPd25Qcm9wcyAmIFVuaGFuZGxlZFByb3BzO1xuXG5jb25zdCByb290U3R5bGVzID0gY3NzKHtcbiAgcG9zaXRpb246ICdyZWxhdGl2ZScsXG4gIGJvcmRlcjogYDFweCBzb2xpZCAke2NvbG9ycy5HUkFZXzMwMH1gLFxuICBib3JkZXJSYWRpdXM6ICcwLjI1cmVtJyxcbiAgYmFja2dyb3VuZENvbG9yOiBjb2xvcnMuV0hJVEUsXG4gIGJveFNpemluZzogJ2JvcmRlci1ib3gnLFxuICAnJiB+ICYnOiB7XG4gICAgbWFyZ2luVG9wOiAnMS41cmVtJyxcbiAgfSxcbn0pO1xuXG5jb25zdCBDYXJkOiBSZWFjdC5GQzxQcm9wcz4gPSAoe1xuICBjaGlsZHJlbixcbiAgLi4udW5oYW5kbGVkUHJvcHNcbn0pID0+IChcbiAgPGRpdiB7Li4udW5oYW5kbGVkUHJvcHN9IGNzcz17cm9vdFN0eWxlc30+XG4gICAge2NoaWxkcmVufVxuICA8L2Rpdj5cbik7XG5cbkNhcmQuZGlzcGxheU5hbWUgPSAnQ2FyZCc7XG5cbmV4cG9ydCBkZWZhdWx0IENhcmQ7XG4iXX0= */");

var Card = function Card(_ref) {
  var children = _ref.children,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("div", _extends({}, unhandledProps, {
    css: rootStyles
  }), children);
};

Card.displayName = 'Card';
export default Card;